window.addEventListener('load', () => {
    let siteMapButton = document.getElementById('siteMapButton');
    let plusVertical = siteMapButton ? siteMapButton.querySelector('.plus-vertical') : null;
    let sitemapHeightWrapper = document.querySelector('.sitemap-height-wrapper');

    if (siteMapButton && plusVertical && sitemapHeightWrapper) {
        siteMapButton.addEventListener('click', () => {
            plusVertical.classList.toggle('active');
            sitemapHeightWrapper.classList.toggle('active');
        });
    }
});